module.exports = __webpack_public_path__ + "static/media/Landing_page_Banner_Desktop@2x.335bdc43.png";